"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useListener_1 = require("../../hooks/useListener/useListener");
const useScreen_1 = require("../../hooks/useScreen/useScreen");
const useRouter_1 = require("../../contexts/useRouter/useRouter");
const useStore_1 = require("../../contexts/useStore/useStore");
const string_1 = require("../../helpers/string/string");
const Search_styled_1 = require("./Search.styled");
const localization_1 = require("../../localization");
const Search = ({ className, searchInitial, onChange }) => {
    const { listen } = (0, useListener_1.useListener)();
    const { isTabletOrSmaller } = (0, useScreen_1.useScreen)();
    const { navigate, location } = (0, useRouter_1.useRouter)();
    const { open } = (0, useStore_1.useStore)();
    const [autofocus, setAutofocus] = (0, react_1.useState)(!isTabletOrSmaller());
    const searchForPattern = (0, react_1.useCallback)((store, pattern, onSearch) => {
        const elements = (0, string_1.cleanStringForSearch)(pattern).split(' ');
        return open(store).where((entity) => {
            const attributes = onSearch(entity.attributes).map((attribute) => (0, string_1.cleanStringForSearch)(attribute?.toString() || ''));
            return elements.every((element) => attributes.some((attribute) => attribute.includes(element)));
        });
    }, [open]);
    const searchInStorage = (0, react_1.useCallback)((value) => {
        if (!value)
            return null;
        const groups = searchForPattern('groups', value, (group) => [group['name']]);
        const people = searchForPattern('people', value, (person) => [
            person['nickname'],
            person['first_name'],
            person['last_name'],
            person['job_alias'],
            person['job']['name'],
            person['lob']['name'],
            person['lob']['abbreviation'],
            open('groups').find(open('groups').find(person['primary_group']?.id)?.attributes['parent']?.id)?.attributes['name'],
            ...person['person_roles'].map(({ role }) => role.name),
        ]);
        const subgroups = searchForPattern('groups', value, (subgroup) => subgroup['group_type'] === 'tribu' ? [subgroup['abbreviation'], subgroup['name']] : []);
        const roles = searchForPattern('roles', value, (role) => [role['name']]);
        const skills = searchForPattern('skills', value, (skill) => [skill['name']]);
        const jobs = searchForPattern('people', value, (person) => [person['job_alias']]);
        const values = {
            ...Object.fromEntries(roles.map((role) => [`roles/${role.id}`, role.attributes['name']]).sort((a, b) => a[1].localeCompare(b[1]))),
            ...Object.fromEntries(people.map((person) => [`people/${person.id}`, person.getFullName()]).sort((a, b) => a[1].localeCompare(b[1]))),
            ...Object.fromEntries(groups.map((group) => [`groups/${group.id}`, group.attributes['name']]).sort((a, b) => a[1].localeCompare(b[1]))),
            ...Object.fromEntries(subgroups.map((subgroup) => [`groups/${subgroup.id}`, subgroup.attributes['name']]).sort((a, b) => a[1].localeCompare(b[1]))),
            ...Object.fromEntries(skills.map((skill) => [`skills/${skill.id}`, skill.attributes['name']]).sort((a, b) => a[1].localeCompare(b[1]))),
            ...Object.fromEntries(jobs.map((person) => [`jobs/${person.attributes['job_alias']}`, person.attributes['job_alias']]).sort((a, b) => a[1].localeCompare(b[1]))),
        };
        onChange?.(values);
        return values;
    }, [searchForPattern, open, onChange]);
    const triggerChangeOnMount = (0, react_1.useCallback)(() => searchInStorage(searchInitial), [searchInitial, searchInStorage]);
    const triggerUpdateAutofocusOnResize = (0, react_1.useCallback)(() => listen('resize', () => (isTabletOrSmaller()
        ? autofocus && setAutofocus(false)
        : !autofocus && setAutofocus(true))), [autofocus, listen, isTabletOrSmaller]);
    (0, react_1.useEffect)(() => { triggerUpdateAutofocusOnResize(); }, [triggerUpdateAutofocusOnResize]);
    (0, react_1.useEffect)(() => { triggerChangeOnMount(); }, [triggerChangeOnMount]);
    return ((0, jsx_runtime_1.jsx)(Search_styled_1.SearchStyled, { className: className, skin: "light", name: localization_1.localization.search.title.label, title: localization_1.localization.search.title.text, valueInitial: { key: null, search: searchInitial || '' }, focused: autofocus && location.route === '/groups', onGroup: (key) => localization_1.localization.search[key.substring(0, key.indexOf('/'))] || null, onSearch: async (value) => searchInStorage(value), onChange: ({ key }) => key && navigate(`/${key}`), onValidate: ({ search }) => navigate(`/search/${search}`) }));
};
exports.Search = Search;
//# sourceMappingURL=Search.js.map